import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '../../config/theme';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: '#3B7E3D',
    borderRadius: '8px',
    color: 'white',
    padding: '12px 16px',
    margin: '24px 0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    fontSize: '1rem',
    fontWeight: 600,
    textDecoration: 'none',
    '& small': {
      fontWeight: 400,
      fontSize: '85%',
      marginLeft: '6px',
      opacity: 0.9,
    },
    '&:hover': {
      backgroundColor: '#316832',
    },
  },
  icon: {
    filter: 'brightness(0) saturate(100%) invert(100%)',
  },
}));

export default function SmallFaq() {
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Link to="/site/faq" className={classes.main}>
        <img src="https://d2zdlj1ifv8u1d.cloudfront.net/images/question.svg" height="22" className={classes.icon} />
        Dúvidas?
        <small>Fale conosco</small>
      </Link>
    </ThemeProvider>
  )
}
